import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import StateComponents from '../../../components/state-component/StateComponents'
import TableCustom from '../../../components/table/tableCustom'
import { debouncedApiCall, getBaseApi } from '../../../utils/app.utils'
import ManageState from './manageState'
import ModalCustom from '../../../components/modal/ModalCustom'
import { useTranslation } from 'react-i18next'

type Props = {}

const Comment: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        file,
        setFile,
        uploadRef,
        handleImportFileItem,
        checkPermit
    } = ManageState()
    const base_image_url = getBaseApi()


    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("ความคิดเห็นจากศิษย์เก่า")}
                hidden_sub_title
                // navigateContent={
                //     <NavigateListCustom
                //         navigateData={[
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("COMPLAINTS_COMPLAINT_SYSTEM"),
                //                 disabled_match: true,
                //                 pathName: ""
                //             },
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("COMPLAINTS_MANAGE_CATEGORY"),
                //                 pathName: routeName.cms.complaintsType
                //             },
                //         ]}
                //     />
                // }
                // buttonContent={
                //     <ContainerButton
                //         justifyContent='flex-end'
                //         buttonData={[
                //             {
                //                 buttonProps: {
                //                     onClick: handleDownloadReport
                //                 },
                //                 key: "DOWNLOAD_CSV",
                //                 label: t("COMPLAINTS_DOWNLOAD_CSV"),
                //                 seq: 1,
                //                 type: "DOWNLOAD_CSV"
                //             }
                //         ]}
                //     />
                // }
                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        placeholder: t("ค้นหา ชื่อ"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: t("ช่วงวันที่")
                                    }
                                },
                                {
                                    type: "COMPONENT",
                                    seq: 3,
                                    fieldProps: {
                                        element: <></>
                                    },
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 6,
                                        md: 2
                                    },
                                    hidden: !checkPermit.isCreated,
                                    fieldProps: {
                                        justifyContent: "flex-end",
                                        buttonData: [
                                            {
                                                seq: 1,
                                                key: "ADD2",
                                                label: t("เพิ่มความคิดเห็น"),
                                                buttonProps: {
                                                    onClick: () => {
                                                        setShowModal("ADD")
                                                    },
                                                },
                                                type: "ADD2"
                                            }
                                        ]
                                    }
                                }
                            ]}
                        />
                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

            {showModal !== '' && (
                <ModalCustom
                    open
                    title={showModal === 'ADD' ? t("เพิ่มความคิดเห็น") : t("ข้อมูลความคิดเห็น")}
                    subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !form.comment_name,
                        hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => handleSubmitForm()
                    }}
                    component={
                        <div className='w-full'>
                            <div>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <div style={{
                                        width: "200px",
                                        height: "200px",
                                        borderRadius: '50%',
                                        border: '5px solid #fff',
                                        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
                                        // marginTop: "-100px",
                                        background: '#fff',
                                        cursor: 'pointer',
                                        overflow: 'hidden'
                                    }} onClick={() => uploadRef?.current?.click()}>
                                        <img src={file ? base_image_url + '/' + file : 'https://placehold.co/600x400?text=No+Img'} style={{ width: '100%', height: "100%", objectFit: 'cover', objectPosition: 'center' }} />
                                    </div>
                                    <input type='file' accept="image/png, image/jpeg" ref={uploadRef} onChange={(obj: any) => handleImportFileItem(obj.target.files[0])} style={{ display: 'none' }} />

                                </div>
                            </div>
                            <StateComponents
                                disabledAllField={showModal === 'VIEW'}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ชื่อ-นามสกุล/ฉายา"),
                                            required: true,
                                            value: form.comment_name,
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, comment_name: e.target.value })),
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("หลักสูตร"),
                                            required: true,
                                            value: form.comment_course,
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, comment_course: e.target.value }))
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ตำแหน่งปัจจุบัน"),
                                            required: true,
                                            value: form.comment_position,
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, comment_position: e.target.value }))
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ความคิดเห็น"),
                                            required: true,
                                            value: form.comment_detail,
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, comment_detail: e.target.value })),
                                            multiline: true,
                                            inputHeight: "auto",
                                            minRow: 3
                                        }
                                    },
                                ]}
                            />
                        </div>
                    }
                />
            )}
        </div>
    )
}

export default Comment